import React from 'react';
import PitchingStatsTable from '../components/PitchingStatsTable';
import { API_ENDPOINTS } from '../config/api';
import { Box } from '@mui/material';

const SeasonPitchingStatsPage = () => {
    return (
        <Box sx={{ p: 3 }}>
            <PitchingStatsTable apiUrl={API_ENDPOINTS.PLAYER_PITCHING_STATS} />
        </Box>
    );
};

export default SeasonPitchingStatsPage; 